<!-- Modal para confirmar el cambio de estado -->
<div class="modal-container">
  <h2 class="modal-title">
    {{ data.estadoNuevo ? '¿Estás seguro de que quieres activar a' : '¿Estás seguro de que quieres desactivar a' }}
    <br>
    {{ data.doctorSeleccionado.use_name }} {{ data.doctorSeleccionado.use_paternal_surname }}?
  </h2>

  <div class="buttons-box row">
    <div class="col">
      <button mat-button class="btn-secondary" (click)="cancelarCambioEstado()">
        <p class="m-0" style="font-weight: 600;">No</p>
      </button>
    </div>
    <div class="col">
      <button mat-raised-button class="btn-primary" color="primary" (click)="confirmarCambioEstado()">
        <p class="m-0" style="font-weight: 600;">Sí</p>
      </button>
    </div>
  </div>
</div>
